export const COLORS = {
  lightBlack: 'rgba(0,0,0,0.7)',
  lighterBlack: 'rgba(0,0,0,0.6)',
  black7: 'rgba(0,0,0,0.1)',
  black6: 'rgba(0,0,0,0.6)',
  black5: 'rgba(0,0,0,0.5)',
  charcoal: '#545454',
  yellow: '#ffe647',
  softYellow: '#fff163',
  navy: '#253342',
  //fadedBlack: '#131414',
  fadedBlack: '#2e2e2e',
  white: '#ffffff',
  blackGray: '#292f38',
  mediumGray: '#8a909b',
  black: '#000000',
  softRed: '#e56c59',
  lightGray: '#d1d1d1',
  whiteGray: '#f2f7ff',
  mediumBlue: '#79b6ce',
  skyBlue: '#96e3ff',
  reactBlue: 'rgb(119, 210, 249)',
  deepBlue: '#1b668e',
  gray50: '#FAFAFA',
  gray100: '#F5F5F5',
  gray200: '#EEEEEE',
  gray300: '#E0E0E0',
  gray400: '#BDBDBF',
  gray500: '#9E9E9E',
  gray600: '#757575',
  gray700: '#616161',
  gray800: '#424242',
  gray900: '#212121',
  blueGrey500: '#607D8B',
  teal100: '#B2DFDB',
  teal500: '#009688',
  teal700: '#00796B',
  orange800: '#EF6C00',
  orange: '#e55c32',
  //orange: '#E45205',
  //orange: '#D25317',
  superLightGray: '#e3ecf9',
  coral: '#FF7A59',
  fadedWhite: '#f0f0f0',
  tealNew: '#00a4bd',
  reactLogoColor: '#61DAFB',
  slateBlue: '#7D91A5',
}

export const orgEmail = 'historiacoop@gmail.com';
export const orgPhone = '7817186148';
export const orgPhoneFormatted = '781.718.6148';

export const LANG = {
  en: 'en',
  es: 'es',
}



// WEBPACK FOOTER //
// ./src/constants.js